import { useEffect } from 'react';

const LMSLoginHandler = ({ onComplete }) => {
  useEffect(() => {
    // Get user data from sessionStorage
    const userDataString = sessionStorage.getItem('_user_data_');
    
    if (!userDataString) {
      console.error('User data not found in sessionStorage');
      if (onComplete) onComplete();
      return;
    }

    let userData;
    try {
      userData = JSON.parse(userDataString);
    } catch (error) {
      console.error('Error parsing user data:', error);
      if (onComplete) onComplete();
      return;
    }

    // Check if lmsDetails exists in user data
    if (!userData.lmsDetails) {
      console.error('LMS details not found in user data');
      if (onComplete) onComplete();
      return;
    }

    const { lmsDetails } = userData;

    // Create form data for POST request
    const formData = new FormData();
    formData.append('un', lmsDetails.un || '');
    formData.append('pw', lmsDetails.pwd || '');
    formData.append('action', lmsDetails.action || 'loginfrm');

    // Log the form data for debugging (remove in production)
    console.log('LMS Login Form Data:', {
      action: lmsDetails.lms_url,
      username: lmsDetails.un,
      action_name: lmsDetails.action
    });

    // Create a temporary form outside the React app
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '-9999px';
    
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = lmsDetails.lms_url || 'https://ksmedu.intellinxt.org/login.php';
    form.target = '_blank';
    form.name = lmsDetails.action || 'loginfrm';

    // Create hidden input fields using dynamic data
    const usernameField = document.createElement('input');
    usernameField.type = 'hidden';
    usernameField.name = 'un';
    usernameField.value = lmsDetails.un || '';

    const passwordField = document.createElement('input');
    passwordField.type = 'hidden';
    passwordField.name = 'pw';
    passwordField.value = lmsDetails.pwd || '';

    const actionField = document.createElement('input');
    actionField.type = 'hidden';
    actionField.name = 'action';
    actionField.value = lmsDetails.action || 'loginfrm';

    // Append fields to form
    form.appendChild(usernameField);
    form.appendChild(passwordField);
    form.appendChild(actionField);
    
    // Append form to temp div
    tempDiv.appendChild(form);
    
    // Append temp div to body (outside React app)
    document.body.appendChild(tempDiv);
    
    // Submit form
    form.submit();

    // Clean up
    document.body.removeChild(tempDiv);

    // Call completion callback if provided
    if (onComplete) {
      onComplete();
    }
  }, [onComplete]);

  return null; // This component doesn't render anything
};

export default LMSLoginHandler;
